/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventValidator } from './EventValidator';
import {
    EventValidatorFromJSON,
    EventValidatorFromJSONTyped,
    EventValidatorToJSON,
    EventValidatorToJSONTyped,
} from './EventValidator';
import type { PrerequisiteType } from './PrerequisiteType';
import {
    PrerequisiteTypeFromJSON,
    PrerequisiteTypeFromJSONTyped,
    PrerequisiteTypeToJSON,
    PrerequisiteTypeToJSONTyped,
} from './PrerequisiteType';

/**
 * 
 * @export
 * @interface Prerequisite
 */
export interface Prerequisite {
    /**
     * 
     * @type {PrerequisiteType}
     * @memberof Prerequisite
     */
    prerequisiteType: PrerequisiteType;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    description?: string;
    /**
     * For LEVEL: minimum GoVIP level required. For TOKEN_BALANCE: minimum token balance required. For SUBSCRIPTION_TIER: minimum subscription tierLevel required (e.g. 1, 2, 3). For MIN_TRUST_SCORE: minimum trustScore [0-100] required to enter. For MIN_ACCOUNT_AGE_DAYS: minimum days since user.createdAt required to enter.
     * 
     * @type {number}
     * @memberof Prerequisite
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    nftGroupingId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    questId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    guildId?: string;
    /**
     * 
     * @type {EventValidator}
     * @memberof Prerequisite
     */
    event?: EventValidator;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    activationId?: string;
    /**
     * 
     * @type {string}
     * @memberof Prerequisite
     */
    streakConfigId?: string;
}



/**
 * Check if a given object implements the Prerequisite interface.
 */
export function instanceOfPrerequisite(value: object): value is Prerequisite {
    if (!('prerequisiteType' in value) || value['prerequisiteType'] === undefined) return false;
    return true;
}

export function PrerequisiteFromJSON(json: any): Prerequisite {
    return PrerequisiteFromJSONTyped(json, false);
}

export function PrerequisiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Prerequisite {
    if (json == null) {
        return json;
    }
    return {
        
        'prerequisiteType': PrerequisiteTypeFromJSON(json['prerequisiteType']),
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'nftGroupingId': json['nftGroupingId'] == null ? undefined : json['nftGroupingId'],
        'questId': json['questId'] == null ? undefined : json['questId'],
        'guildId': json['guildId'] == null ? undefined : json['guildId'],
        'event': json['event'] == null ? undefined : EventValidatorFromJSON(json['event']),
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'activationId': json['activationId'] == null ? undefined : json['activationId'],
        'streakConfigId': json['streakConfigId'] == null ? undefined : json['streakConfigId'],
    };
}

export function PrerequisiteToJSON(json: any): Prerequisite {
    return PrerequisiteToJSONTyped(json, false);
}

export function PrerequisiteToJSONTyped(value?: Prerequisite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'prerequisiteType': PrerequisiteTypeToJSON(value['prerequisiteType']),
        'description': value['description'],
        'amount': value['amount'],
        'nftGroupingId': value['nftGroupingId'],
        'questId': value['questId'],
        'guildId': value['guildId'],
        'event': EventValidatorToJSON(value['event']),
        'challengeId': value['challengeId'],
        'activationId': value['activationId'],
        'streakConfigId': value['streakConfigId'],
    };
}

